/* eslint-disable no-undefined */
/* eslint-disable max-len */
/* eslint-disable consistent-return */
/* eslint-disable no-inline-comments */
/* eslint-disable consistent-this */
/* eslint-disable no-unused-vars */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import axios from 'axios'
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
  Link
} from 'react-router-dom'
import { withStyles } from '@material-ui/core/styles'
import Snackbar from '@material-ui/core/Snackbar'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'
import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import { connect } from 'react-redux'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import Teststats from './pages/MyTestResults_all.js';
import MyCertificates from './pages/MyTestResume_all.js';
import Progressbar from './components/ProgressBar'

// // Pages
import SignIn from './pages/Auth/SignIn'
import LandingPage from './pages/Auth/LandingPage'
import SignUp from './pages/Auth/SignUp'
import ForgotPassword from './pages/Auth/ForgotPassword'
import TermsConditions from './pages/TermsConditions'
import CompanyAdmin from './pages/CompanyAdmin'
import LcSettings from './pages/Admin/LcSettings'
import LcEarningsMonitor from './pages/Admin/LcEarningsMonitor'
import getmembers from './components/monitor/getMembers.js'
import BlacklistTable from './components/monitor/BlacklistTable.js'

import orgEval from './components/UserProfile/orgEval.js'
import orgStats from './pages/PLDP/Competencies/orgStats.js'

import genEval from './components/UserProfile/genEval.js'
import genStats from './pages/PLDP/Competencies/genStats.js'

import Organisational from './pages/Organisational'
import MyGroups from './pages/MyGroups'
import FilteredPosts from './pages/filteredPosts'
import Gotopatreon from './pages/Gotopatreon'
import GotoPersonPledge from './pages/GotoPersonPledge'
import GotoBulkPledge from './pages/GotoBulkPledge'
import GotoFlexPledge from './pages/GotoFlexPledge'
import GotoGIFpledge from './pages/GotoGIFpledge'
import GotoMalik from './pages/GotoMalik'
import ExecutiveMembersTable from './pages/totLc'
import PLDP from './pages/PLDP'
//import TikTokThoughtsCard from './components/Cards/TikTokThoughtsCard.js'

import pldp_ledain from './pages/PLDP/Competencies/index_ledain'

import Favourites from './pages/Favourites'
//import Wallet from './pages/Sendmecoins'
import Wallet from './pages/RealMEVChart'
import Navbar from './components/layout/Navbar'
import Ilead from './pages/Ilead'
//import AgentDashboard from './components/AgentDashboard';
//import About from './pages/About'
import LeaderOnList from './components/Dialogs/LeaderList'
import mevcoin from './components/Dialogs/mevcoin'
import GcThoughts from './pages/gcThoughts'
import DailyThoughts from './pages/dailyThoughts'
import MyPosts from './pages/MyPosts'
import Surveys from './pages/Surveys'
import PointsSurveys from './pages/PointsSurveys'
import Agentlist from './components/monitor/Agentlist.js'
import Videos from './pages/Videos'
import Podcasts from './pages/Podcasts'
import Poe from './pages/Poe'
import Articles from './pages/Articles'
import Ebooks from './pages/Ebooks'
import Bookshop from './pages/Bookshop'
import Analytics from './pages/Analytics'
import TutorialsPage from './pages/Tutorials/index'
import Competencies from './pages/Competencies'
import Tokens from './pages/Tokens.js'
import Companies from './pages/Companies'
import UserProfile from './components/UserProfile'
import Groups from './components/groups'
import MEVSettings from './components/MEVSettings'
import WebSourceSettings from './components/WebSourceSettings'
import cosign from './components/cosign'
import monitor from './components/monitor'
import fixcompany from './components/fixcompany'
import liqA from './pages/liq'
import liqB from './pages/liq2'

import StudyMaterials from './components/groups/StudyMaterials'
import Programmes from './components/groups/Programmes'
import SurveyConfigurations from './components/groups/SurveyConfigurations'
import Facilitators from './components/groups/Facilitators'
import GroupCourses from './components/groups/GroupCourses'
import GroupDetails from './components/groups/groupDetails'
import FileRepo from './pages/FileRepo'
import ReadArticles from './components/Views/ReadArticles'
import MainSpeedDial from './components/MainSpeedDial'
import AddModal from './components/Dialogs/AddModal'
import ToastMessage from './components/ToastMessage'
import LoaderBar from './components/LoaderBar'
import ViewUserProfile from './components/UserProfile/ViewUserProfile'
import FileViewer from './components/FileViewer'

import TestOTP from './components/TestOTP'
import { hideToast, showToast } from './store/actions/toastAction'
import { hideLoader, showLoader } from './store/actions/loaderActions'
import { authStateChanged, getIsValidatingCredentials, getIsGoogleAuthInProgress, getGoogleAuthMode } from './store/actions/authActions'
import { loggedInProfileActions } from './store/actions/loggedInProfileActions'
import { getScores, handleOAuthRedirectRequest, getUserProfile } from './store/actions/companyAdminActions'
// Add fetchCompanyData from loggedInCompanyActions:
import { fetchCompanyData } from './store/actions/loggedInCompanyActions'
import { createThought } from './store/actions/thoughtsActions'
import { createVideo } from './store/actions/videosActions'
import { createPodcast } from './store/actions/podcastsActions'
import { createArticle } from './store/actions/articlesActions'
import { addMorePoints } from './store/actions/freshCardActions'
import { calculateTestPassed, calculateLCEarned } from './utils/test_utils'
import { fetchSettingsFromDB, subscribeSettings } from './utils/lc_settings'
//import {AgentDashboard} from './AgentDash/AgentDashboard'
import AgentDashboard from './components/AgentDashboard.jsx'
import SafeguardingDashboard from './components/SafeguardingDashboard'

//import mevprice from './pages/mev_price.js'
import MevPriceWidget from './pages/MevPriceWidget';

import ReconnectingBanner from "./ReconnectingBanner"; // we'll create this
import NotificationStatus from './components/NotificationStatus';

import { isMobile } from 'react-device-detect'

import {
  APP_TYPE,
  USER_LOGGED_IN,
  GLP_LOGGED_COMPANY,
  GLP_LOGGED_PROFILE,
  SHOW_TOAST,
  SHOW_LOADER,
  HIDE_LOADER,
  BLOCKED_USER_TYPES,
  PUBLIC_COMPANY_ID,
  ACCESS_COMPETENCIES,
  SUPPORTED_FILE_TYPES,
  HIDE_ADD_BTN,
  SHOW_SPEEDDIAL,
  FB_URL
} from './store/actions/types'

import firebase from './store/firebase'
import Search from './pages/Search'
import Gotocalf from './pages/Gotocalf'
//import Gotopatreon from './pages/Gotopatreon'

import MyTestResults from './pages/MyTestResults'
import MyTestResume from './pages/MyTestResume'

import packageJson from '../package.json'
// import { getBuildDate } from "./utils/utils";
import withClearCache from './ClearCache'
import moment from 'moment'
import Individuals from './pages/Individuals'
import Organizations from './pages/Organizations'
import SupportContact from './components/LandingPage/SupportContact'
import ReAuthTOTP from './ReAuthTOTP';

import LinkAccount from './pages/LinkAccount';
import AgentSignup from './pages/AgentSignup';

import { FCMInitialiser } from './utils/useFCMNotifications';

import * as OTPAuth from 'otpauth';

const drawerWidth = 280
const topHeight = 64

const styles = (theme) => ({
  root: {
    // width: "100%"
    width: 'calc(100% - 1px)',
  },
  grow: {
    flexGrow: 1
  },
  content: {
    marginTop: topHeight,
    padding: '10px',
    [theme.breakpoints.up('sm')]: {
      marginLeft: drawerWidth
    },
    [theme.breakpoints.down('md')]: {
      padding: '0',
      marginTop: '90px!important'
    }
  }
})

export const getBuildDate = (epoch) => {
  const buildDate = moment(epoch).format('DD-MM-YYY HH:MM')
  return buildDate
}

class App extends Component {
  state = {
    reAuthKey: 0,
    cachedTotpSecret: null, 
    userloggedin: false,
    opendialog: false,
    openfileviewer: false,
    dialogname: '',
    loading: true,
    filename: '',
    filetype: 'pdf',
    filepath: '',
    Gotopatreon: false,
    // Certificate modal state
    showCertModal: false,
    certModalLabel: '',
    certQueue: [],
    timeNow: '',
    showReconnecting: false,
    showReconnecting: false,
    dbConnectionListener: null,
    connectedRef: null,
    authRefreshListener: null,   // ← NEW
    showReAuthScreen: false,
    lastActivityTime: Date.now(),
    reAuthListenerAttached: false,   // prevent duplicate listeners
  };

  openModal = (modalName) => {
    this.setState((state) => ({
      opendialog: true,
      dialogname: modalName
    }))
    };

  handleModalClose = () => {
    this.setState((state) => ({
      opendialog: false,
      dialogname: ''
    }))
  };

  handleFileViewerClose = () => {
    this.setState((state) => ({
      openfileviewer: false,
      filename: '',
      filetype: '',
      filepath: ''
    }))
  };

  openFileViewer = (file) => {
    try {
      let filename = file.filename || ''
      const filepath = file.filepath
      // Derive extension from filename; if missing, try from URL
      let ext = ''
      if (filename && filename.includes('.')) {
        const lastDot = filename.lastIndexOf('.')
        ext = filename.substring(lastDot + 1)
        filename = filename.substring(0, lastDot)
      } else if (filepath) {
        try {
          const url = new URL(filepath)
          const pathname = url.pathname
          const dot = pathname.lastIndexOf('.')
          if (dot !== -1) {
            ext = pathname.substring(dot + 1)
          }
        } catch (_) {
          const dot = filepath.lastIndexOf('.')
          if (dot !== -1) {
            ext = filepath.substring(dot + 1)
          }
        }
      }

      if (SUPPORTED_FILE_TYPES[(ext || '').toLowerCase()]) {
        this.setState((state) => ({
          openfileviewer: true,
          filetype: ext,
          filepath: filepath,
          filename: filename || (file.filename || '')
        }))
      } else {
        // Still open in viewer but pass empty/unknown type; viewer component handles iframe fallbacks
        this.setState((state) => ({
          openfileviewer: true,
          filetype: (ext || '').toLowerCase(),
          filepath: filepath,
          filename: filename || (file.filename || '')
        }))
      }
    } catch (error) {

      }
  };

tryRestoreAuthState = async () => {
  try {
    // Wait a tiny bit for Firebase to settle after tab focus
    await new Promise(resolve => setTimeout(resolve, 300));

    const currentUser = firebase.auth.currentUser;
    if (currentUser) {
      console.log("✅ Restored auth from currentUser after refresh failure");
      return;
    }

    // If still no user, manually trigger a re-check of the auth state
    // This often forces Firebase to use the persisted refresh token
    firebase.auth.onAuthStateChanged(() => {}); // dummy listener to kick the SDK

    // Fallback: re-run your existing auth logic by simulating a state change
    setTimeout(() => {
      const userAfterRestore = firebase.auth.currentUser;
      if (userAfterRestore && !this.state.userloggedin) {
        console.log("✅ Session restored via fallback");
        // Trigger your normal login flow with the restored user
        // (you can extract the userobj logic into a reusable method if you want)
        this.setState({ ...this.state, userloggedin: true });
        self.setState({ ...self.state, userloggedin: true, lastActivityTime: Date.now() });
        localStorage.setItem('lastActivityTime', Date.now().toString());
      }
    }, 800);
  } catch (e) {
    console.warn("Session restore failed", e);
  }
};

forceAuthTokenRefresh = async () => {
  const user = firebase.auth.currentUser;
  if (!user) {
    // No current user in memory → try to restore from persistence
    this.tryRestoreAuthState();
    return;
  }

  try {
    // Force refresh the ID token
    await user.getIdToken(true);
    console.log("✅ Firebase Auth token forcibly refreshed on tab focus");

    // Wake up Realtime Database
    try {
      firebase.database.goOnline();
    } catch (_) {}
    
    // Re-attach DB listener if needed
    if (this.state.userloggedin) {
      this.attachDbConnectionListener();
    }
  } catch (err) {
    console.warn("⚠️ Forced token refresh failed, attempting session restore...", err);
    this.tryRestoreAuthState();
  }
};

// Visibility / focus handler
handleTabVisibilityChange = () => {
  if (document.visibilityState === "visible") {
    this.checkInactivityAndReAuth();
  }
};

// Extracted so it can be called from multiple places
// checkInactivityAndReAuth = () => {
//   if (!this.state.userloggedin) return;
//   if (this.state.showReAuthScreen) return;

//   const now = Date.now();
//   const inactiveTimeMinutes = (now - this.state.lastActivityTime) / 1000 / 60;

//   const inacProp = this.props.userdata?.inactiveTime ?? 3;

//   console.log('checkInactivityAndReAuth - inacProp:', inacProp);
//   console.log('checkInactivityAndReAuth - inactiveTimeMinutes:', inactiveTimeMinutes.toFixed(2));

//   if (inacProp !== 0 && inactiveTimeMinutes > inacProp) {
//     console.log("🔒 Inactivity threshold exceeded — showing TOTP re-auth");
//     firebase.database.goOffline();
//     sessionStorage.setItem('reAuthRequired', 'true'); // sessionStorage only — see componentDidMount cleanup
//     this.setState({ showReAuthScreen: true });
//     this.detachDbConnectionListener();
//   }
// };

checkInactivityAndReAuth = () => {
  if (!this.state.userloggedin) return;
  if (this.state.showReAuthScreen) return;
  if (!this.props.userdata) return;

  // Never trigger reAuth if the user hasn't set up TOTP — they would
  // have no way to get back into their account.
  if (!this.props.userdata.totpEnabled || !this.props.userdata.totpSecret) {
    return;
  }

  const now = Date.now();
  const inactiveTimeMinutes = (now - this.state.lastActivityTime) / 1000 / 60;
  const inacProp = this.props.userdata.inactiveTime ?? 3;

  console.log('checkInactivityAndReAuth - inacProp:', inacProp);
  console.log('checkInactivityAndReAuth - inactiveTimeMinutes:', inactiveTimeMinutes.toFixed(2));

  if (inacProp !== 0 && inactiveTimeMinutes > inacProp) {
    console.log("🔒 Inactivity threshold exceeded — showing TOTP re-auth");
    firebase.database.goOffline();
    sessionStorage.setItem('reAuthRequired', 'true');
    this.setState({ showReAuthScreen: true });
    this.detachDbConnectionListener();
  }
};

handleTabVisibilityChange_works = () => {
  if (document.visibilityState === "visible") {
    const inactiveMinutes = (Date.now() - this.state.lastActivityTime) / 1000 / 60;

    console.log(`Tab focused — inactive for ${inactiveMinutes.toFixed(1)} minutes`);

    if (inactiveMinutes > 3) {   // change back to 60 when testing is done
      console.log("🔒 Long inactivity detected — showing TOTP re-auth screen");
     // Wherever you trigger the ReAuth screen:
      firebase.database.goOffline();
      // Wherever you trigger the ReAuth screen:
      sessionStorage.setItem('reAuthRequired', 'true');
      localStorage.setItem('reAuthRequired', 'true');
      this.setState({ showReAuthScreen: true });
      this.detachDbConnectionListener();
    } else {
      // Normal short inactivity — just refresh token
      this.forceAuthTokenRefresh();
    }
  }
};

handleTabVisibilityChange_default = () => {
  if (document.visibilityState === "visible") {
 const timeInactive = (Date.now() - this.state.lastActivityTime) / 1000 / 60; // minutes
 const inacProp = this.props.userdata.inactiveTime ? this.props.userdata.inactiveTime : 60;
 if (inacProp!==0) {
  if (timeInactive > inacProp) {  // 60+ minutes inactive
   console.log("Long inactivity detected — showing TOTP re-auth");
   // Wherever you trigger the ReAuth screen:
    firebase.database.goOffline();
    // Wherever you trigger the ReAuth screen:
    sessionStorage.setItem('reAuthRequired', 'true');
    localStorage.setItem('reAuthRequired', 'true');
    this.setState({ showReAuthScreen: true });
    this.detachDbConnectionListener();
  } else {
   this.forceAuthTokenRefresh(); // your existing refresh
  }
 }

  } else {
    // Tab hidden → update last activity? Or leave it
  }
};

// Also update last activity on user interaction (click, keypress, etc.)
updateActivityTime = () => {
  const now = Date.now();
  this.setState({ lastActivityTime: now });
  localStorage.setItem('lastActivityTime', now.toString());
};

componentDidUpdate = (prevProps, prevState) => {
  // === NEW: Attach DB connection listener ONLY after successful login ===
  if (this.state.userloggedin && !prevState.userloggedin) {
    this.attachDbConnectionListener();
  }
  if (!this.state.userloggedin && prevState.userloggedin) {
    this.detachDbConnectionListener();
  }

  let self = this
  // if (this.props.userdata) {
  // }
 
  // if (this.props.userdata) {
  //   var newPay;
  //   var timeNow;
  //   var lastPay;
    
  //   //IF PATRON then DISTRIBUT PLEDGE IN USER LC and LC POOL
  //     if (this.props.userdata.payoutdate && this.props.userdata.patron) { //have payed out before
  //       timeNow = (new Date().getTime())/(86400000);
  //       lastPay = this.props.userdata.payoutdate;

  //       newPay = timeNow - lastPay

  //       if (newPay > 0) { //IF user is patron AND user LC hasnt been updated for more than 30 days
  //         this.setState({Gotopatreon: true})
  //       }
  //       else
  //       {
  //         //do nothing
  //       }
  //     } 
  // }

  if (this.props.opentoast === true) {
    setTimeout(() => {
      self.props.hideToast()
    }, 6000)
  }
  // Set up or tear down the certificate listener when user data changes
  try {
    if (this.props.userdata && !this._certListenerRef) {
      this.setupCertificateListener()
    }
    if (!this.props.userdata && this._certListenerRef) {
      this.teardownCertificateListener()
    }
  } catch (_) {}
  // Ensure live LC subscription is bound to current companyID
  try {
    const currCompany = this.props.userdata && this.props.userdata.companyID
    if (this._lcCompany !== currCompany) {
      try { this._lcUnsub && this._lcUnsub(); } catch (_) {}
      this._lcCompany = currCompany
      try { this._lcUnsub = subscribeSettings({ companyID: currCompany }); } catch (_) {}
    }
  } catch (_) {}
};

fixFuturePointsTrailDates = async () => {
  try {
    //2026-02-13 00:00 live
    //2026-02-17 00:00 test

      const db = firebase.database;
     // const userRef = db.ref(`pointsTrail`);
      const userRef = db.ref(`MEVDATA`);

      const snapshot = await userRef.once('value');
    console.log('fixFuturePointsTrailDates 1');
    if (!snapshot.exists()) {
      console.log("No pointsTrail data found.");
      return;
    }

    const data = snapshot.val();
    const cutoffDate = new Date("2026-02-24T00:00:00");
    const newDateString = "2026-02-17 02:00";

    const updates = {};
console.log('fixFuturePointsTrailDates 2');
  Object.keys(data).forEach((pointsID) => {
      const entry = data[pointsID];
console.log('fixFuturePointsTrailDates 3');
      if (!entry || !entry.fdate) return;

      let parsedDate;

      // CASE 1: fdate is a string
      if (typeof entry.fdate === "string") {
        parsedDate = new Date(entry.fdate.replace(" ", "T"));
      }

      // CASE 2: fdate is a number (timestamp)
      else if (typeof entry.fdate === "number") {
        parsedDate = new Date(entry.fdate);
      }
      // CASE 3: anything else → skip
      else {
        console.log(`Skipping invalid fdate type for ${pointsID}`);
        return;
      }

      if (!isNaN(parsedDate) && parsedDate >= cutoffDate) {
        //updates[`pointsTrail/${pointsID}/fdate`] = newDateString;
        updates[`MEVDATA/${pointsID}/fdate`] = newDateString;
      }
    });

    if (Object.keys(updates).length > 0) {
           var res = await axios.post(`${FB_URL}/m115-freshcard`, {
            params: {
                updates: updates, //user wallet address                       
            }
          })

      if (res.data || res.data.success === true) {
         console.log('fixFuturePointsTrailDates Success !');
        }
        else {
        console.log('fixFuturePointsTrailDates Err');
        };

      console.log(`Updated ${Object.keys(updates).length} records.`);
    } else {
      console.log("No records needed updating.");
    }

  } catch (error) {
    console.error("fixFuturePointsTrailDates Error updating pointsTrail:", error);
  }
};

attachDbConnectionListener = () => {
  if (this.state.dbConnectionListener) return;

  this.connectedRef = firebase.database.ref(".info/connected");
  this.dbConnectionListener = this.connectedRef.on("value", (snapshot) => {
    const connected = snapshot.val() === true;

    this.setState({
      showReconnecting: !connected,
    });

    if (connected) {
      console.log("✅ Firebase Realtime DB connected — dbReady: true");
    } else {
      console.warn("❌ Firebase Realtime DB disconnected — dbReady: false");
    }
  });
};

detachDbConnectionListener = () => {
  if (this.connectedRef && this.dbConnectionListener) {
    this.connectedRef.off("value", this.dbConnectionListener);
  }
  this.setState({ showReconnecting: false });
  this.connectedRef = null;
  this.dbConnectionListener = null;
};

componentDidMount = async () => {
// ── COLD START SECURITY CHECK ──
const persistedLastActivity = parseInt(localStorage.getItem('lastActivityTime') || '0', 10);
let storedUid = null;
try {
  const storedUser = JSON.parse(localStorage.getItem('USER_LOGGED_IN') || '{}');
  storedUid = storedUser?.uid;
} catch (e) {}

if (persistedLastActivity && storedUid) {
  let inacPropColdStart = 3; // safe default if read fails
  let totpEnabledColdStart = false;

  try {
    const snap = await firebase.database.ref(`user/${storedUid}`).once('value');
    const profile = snap.val();
    if (profile) {
      inacPropColdStart = profile.inactiveTime ?? 3;
      totpEnabledColdStart = !!(profile.totpEnabled && profile.totpSecret);
    }
  } catch (e) {
    console.warn('Cold start: could not read profile, skipping reAuth check:', e.message);
  }

  if (totpEnabledColdStart) {
    const inactiveMinutesColdStart = (Date.now() - persistedLastActivity) / 1000 / 60;

    console.log('Cold start check — inacPropColdStart:', inacPropColdStart);
    console.log('Cold start check — inactive minutes since last activity:', inactiveMinutesColdStart.toFixed(2));

    if (inacPropColdStart !== 0 && inactiveMinutesColdStart > inacPropColdStart) {
      console.log('🔒 Cold start — inactivity threshold exceeded, forcing reAuth before render');
      sessionStorage.setItem('reAuthRequired', 'true');
    }
  } else {
    console.log('Cold start — TOTP not configured for this user, skipping reAuth check');
  }
}
// ── END COLD START SECURITY CHECK ──
  
// Clean up any stuck localStorage flag from previous sessions
localStorage.removeItem('reAuthRequired');

  // Only show ReAuth if sessionStorage flag is set AND there is a known user
  const reAuthRequired = sessionStorage.getItem('reAuthRequired') === 'true';
  const hasKnownUser2 = !!localStorage.getItem('USER_LOGGED_IN');

if (reAuthRequired && hasKnownUser2) {
  this.setState({ showReAuthScreen: true });

  const unsubscribe = firebase.auth.onAuthStateChanged(async (user) => {
    unsubscribe();
    if (user) {
      try {
        const snap = await firebase.database
          .ref(`user/${user.uid}/totpSecret`)
          .once('value');
        if (snap.val()) {
          this.setState({ cachedTotpSecret: snap.val() });
          sessionStorage.setItem('cachedTotpSecret', snap.val()); // ← fixed typo: was totpSnap
          console.log('ReAuth: totpSecret reloaded after refresh');
        }
      } catch (err) {
        console.warn('ReAuth: could not reload totpSecret:', err.message);
      }
    }
  });
}

  const { userdata } = this.props;

  let self = this;

  this.getCentralTime();

  try { fetchSettingsFromDB(); } catch (_) {}

  try { this._lcUnsub && this._lcUnsub(); } catch (_) {}

  try {
    this._lcCompany = userdata && userdata.companyID;
    this._lcUnsub = subscribeSettings({ companyID: this._lcCompany });
  } catch (_) {}

  // ================================
  // FIREBASE AUTH PERSISTENCE
  // ================================
  try {
    await firebase.auth.setPersistence(firebase.auth_.Auth.Persistence.LOCAL);
    console.log("✅ Firebase auth persistence set to LOCAL");
  } catch (e) {
    console.warn("Auth persistence error:", e);
  }

  // ================================
  // INVITE PARAMETER CAPTURE
  // ================================
  try {
    const params = new URLSearchParams(window.location.search || '');
    const inviteCompanyID = params.get('id');
    const inviterUID = params.get('u') || params.get('inviter') || null;

    if (inviteCompanyID) {
      const payload = {
        companyID: inviteCompanyID,
        inviterUID,
        ts: Date.now()
      };

      console.log('[INVITE] captured from URL', payload);
      localStorage.setItem('INVITE_DATA', JSON.stringify(payload));
    }
  } catch (e) {
    console.log('app.js invite capture error:', e.message);
  }

  // ================================
  // AXIOS INTERCEPTORS
  // ================================
  this._axiosReqInterceptor = axios.interceptors.request.use(
    (config) => {
      try { self.props.showLoader({ type: SHOW_LOADER }); } catch (_) {}
      return config;
    },
    (error) => {
      try { self.props.showLoader({ type: HIDE_LOADER }); } catch (_) {}
      return Promise.reject(error);
    }
  );

  this._axiosResInterceptor = axios.interceptors.response.use(
    (response) => {
      try { self.props.showLoader({ type: HIDE_LOADER }); } catch (_) {}
      return response;
    },
    (error) => {
      try { self.props.showLoader({ type: HIDE_LOADER }); } catch (_) {}
      return Promise.reject(error);
    }
  );

  // ================================
  // FIREBASE REALTIME DB CONNECTION MONITOR
  // ================================
  // try {
  //   this.connectedRef = firebase.database.ref(".info/connected");

  //   this.dbConnectionListener = this.connectedRef.on("value", (snapshot) => {
  //     const connected = snapshot.val() === true;

  //     this.setState({ showReconnecting: !connected });

  //     if (connected) {
  //       console.log("✅ Firebase Realtime DB connected");
  //     } else {
  //       console.warn("❌ Firebase Realtime DB disconnected");
  //     }
  //   });
  // } catch (e) {
  //   console.warn("DB connection monitor error:", e);
  // }

  // ================================
// KEEP FIREBASE CONNECTION ALIVE
// ================================
try {
  this.keepAliveInterval = setInterval(async () => {
    // Keep database connection alive
    firebase.database
      .ref(".info/serverTimeOffset")
      .once("value")
      .catch(() => {});

    // Silently refresh Auth token in background
    try {
      const user = firebase.auth.currentUser;
      if (user) {
        user.getIdToken(true).catch(() => {});
      }
    } catch (e) {}
  }, 60000);

  console.log("🔄 Firebase keepAlive ping enabled");
} catch (e) {
  console.warn("KeepAlive error:", e);
}

// ================================
// CHECK INITIAL DATABASE CONNECTION    ← ADD THIS BLOCK HERE
// ================================
// try {
//   firebase.database
//     .ref(".info/connected")
//     .once('value')
//     .then((snap) => {
//       if (snap.val() === true) {
//         this.setState({ dbReady: true });
//         console.log("✅ Initial database connection confirmed — dbReady: true");
//       } else {
//         console.warn("⚠️ Database not connected on initial load");
//       }
//     })
//     .catch(() => {});
// } catch (e) {
//   console.warn("Initial DB check error:", e);
// }

// ================================
// AUTH STATE LISTENER                  ← your existing code continues here
// ================================
this.authChangeTimer = null;

firebase.auth.onAuthStateChanged(function (user) {

  // ── DIAGNOSTIC: remove after debugging ──
  console.log('=== AUTH STATE CHANGED ===', new Date().toISOString());
  console.log('AUTH STATE: user:', user?.uid ?? 'NULL');
  console.log('AUTH STATE: firebase auth keys in LS:', Object.keys(localStorage).filter(k => k.startsWith('firebase:')));
  console.log('AUTH STATE: reAuthRequired SS:', sessionStorage.getItem('reAuthRequired'));
  console.log('AUTH STATE: reAuthRequired LS:', localStorage.getItem('reAuthRequired'));
  console.log('AUTH STATE: USER_LOGGED_IN:', localStorage.getItem('USER_LOGGED_IN') ? 'present' : 'MISSING');
  console.trace('call stack:');
  // ── END DIAGNOSTIC ──

  if (getIsValidatingCredentials()) {
    return;
  }

  // Clear timer
  if (self.authChangeTimer) {
    clearTimeout(self.authChangeTimer);
  }

  self.authChangeTimer = setTimeout(async () => {

  // ── DIAGNOSTIC: remove after debugging ──
  console.log('=== INSIDE setTimeout (debounced) ===', new Date().toISOString());
  console.log('INSIDE setTimeout: user inside timer:', user?.uid ?? 'NULL');
  console.log('INSIDE setTimeout: reAuthRequired SS:', sessionStorage.getItem('reAuthRequired'));
  console.log('INSIDE setTimeout: reAuthRequired LS:', localStorage.getItem('reAuthRequired'));
  // ── END DIAGNOSTIC ──

    if (user) {

      try {
        const mode = getGoogleAuthMode ? getGoogleAuthMode() : 'idle';
        const uid = user.uid;

        const snapshot = await firebase.database
          .ref(`user/${uid}`)
          .once('value');

        const hasAccount = !!snapshot.val();

        if (!hasAccount && mode === 'login') {

          await firebase.auth.signOut();
          sessionStorage.removeItem('reAuthRequired');

          self.setState({ ...self.state, userloggedin: false });

          localStorage.removeItem('USER_LOGGED_IN');
          localStorage.removeItem('GLP_LOGGED_COMPANY');
          localStorage.removeItem('GLP_LOGGED_PROFILE');

          if (self.props.showToast) {
            self.props.showToast({
              type: 'warning',
              message: 'Google sign-in is restricted. Your email is not registered on this system. Go to CREATE ACCOUNT → Sign up with Google.',
              pos: 'top'
            });
          }

          return null;
        }

      } catch (_) {}

      let displayName = '';

      if (!user.displayName) {
        displayName = user.email.substring(0, user.email.indexOf('@'));
      } else {
        displayName = user.displayName;
      }

      let userobj = {
        uid: user.uid,
        displayName,
        email: user.email,
        emailVerified: user.emailVerified,
        refreshToken: user.refreshToken,
        metadata: user.metadata
      };

      self.props.getScores({
        uid: user.uid,
        email: user.email
      });

      self.setState({ ...self.state, userloggedin: true, lastActivityTime: Date.now() });
      localStorage.setItem('lastActivityTime', Date.now().toString());

      localStorage.setItem('USER_LOGGED_IN', JSON.stringify(userobj));

      self.props.authStateChanged(userobj);

      self.props.loggedInProfileActions(userobj.uid)

      // ---- Cache totpSecret for offline ReAuth use ----
      // Loaded here while database is definitely connected,
      // so ReAuth never needs to make a database read.
      try {
        const totpSnap = await firebase.database
          .ref(`user/${user.uid}/totpSecret`)
          .once('value');
        if (totpSnap.val()) {
          self.setState({ cachedTotpSecret: totpSnap.val() });
          sessionStorage.setItem('cachedTotpSecret', totpSnap.val());
          console.log('App.js: totpSecret cached for ReAuth');
        }
      } catch (totpErr) {
        console.warn('App.js: could not cache totpSecret:', totpErr.message);
      }
      return user  // ← this line was already there
    }

    // Do not sign out if ReAuth is in progress
    const reAuthRequired = sessionStorage.getItem('reAuthRequired') === 'true';

    if (reAuthRequired) {
      console.log('onAuthStateChanged: user null but reAuthRequired — keeping session');
      return null;
    }
    self.setState({ ...self.state, userloggedin: false });
    localStorage.removeItem('USER_LOGGED_IN');
    localStorage.removeItem('GLP_LOGGED_COMPANY');
    localStorage.removeItem('GLP_LOGGED_PROFILE');
    return null;

  }, 100);

});

  // ================================
  // GLOBAL FILE VIEWER EVENT
  // ================================
  try {
    window.addEventListener('OPEN_FILE_VIEWER', (evt) => {
      const file = evt && evt.detail ? evt.detail : null;
      if (file && self.openFileViewer) {
        self.openFileViewer(file);
      }
    });
  } catch (_) {}

  // ================================
  // CERTIFICATE EVENT LISTENER
  // ================================
  try {
    this._certEvtHandler = (evt) => {
      try {
        const label = (evt && evt.detail && evt.detail.label) || 'a new certificate';
        this.enqueueCertModal(label);
      } catch (_) {}
    };

    window.addEventListener('CERT_EARNED', this._certEvtHandler);
  } catch (_) {}

  // ================================
  // CERTIFICATE LISTENER INIT
  // ================================
  try {
    if (this.props.userdata && !this._certListenerRef) {
      this.setupCertificateListener();
    }
  } catch (_) {}

  // === NEW: Tab visibility / focus handler for long-inactive tabs ===
  // (This must be at the bottom of componentDidMount)
  this.authRefreshListener = this.handleTabVisibilityChange;
  document.addEventListener("visibilitychange", this.authRefreshListener);

// ================================
// INACTIVITY & RE-AUTH LISTENERS
// ================================
this.updateActivityTime();

const throttledActivity = this.throttle(this.updateActivityTime, 2000);
document.addEventListener('click', throttledActivity);
document.addEventListener('mousemove', throttledActivity);
document.addEventListener('keypress', throttledActivity);
document.addEventListener('scroll', throttledActivity);

// visibilitychange — fires when tab is switched back to
document.addEventListener("visibilitychange", this.handleTabVisibilityChange);
this.authRefreshListener = this.handleTabVisibilityChange;

// focus — fires when window regains focus after being minimised or
// after the computer wakes from sleep
window.addEventListener('focus', this.checkInactivityAndReAuth);  // ← ADD

// Periodic check every 30 seconds — catches cases where neither
// visibilitychange nor focus fires (e.g. tab was already visible
// when computer woke from sleep)
this.inactivityCheckInterval = setInterval(       // ← ADD
  this.checkInactivityAndReAuth,
  30000
);

console.log("✅ Inactivity & re-auth listeners attached");
  //////////////////////////////////////////////////////////////////////////////////
  //   this.resetLastActivityTime = () => {
  //   this.setState({ lastActivityTime: Date.now() });
  // };

  // // Update last activity on real user actions
  // const activityEvents = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart'];
  
  // activityEvents.forEach(event => {
  //   document.addEventListener(event, this.resetLastActivityTime, { passive: true });
  // });

  // // Also listen to visibility change
  // document.addEventListener('visibilitychange', this.handleTabVisibilityChange);

  // // Initial value
  // if (!this.state.lastActivityTime) {
  //   this.setState({ lastActivityTime: Date.now() });
  // }
};

componentDidMount_jun8 = async () => {
  const reAuthRequired = sessionStorage.getItem('reAuthRequired') === 'true';
  if (reAuthRequired) {
    this.setState({ showReAuthScreen: true });

    // Wait for Firebase Auth to restore session before reading totpSecret.
    // currentUser is null immediately on page load — onAuthStateChanged
    // fires once Auth has rehydrated from localStorage.
    const unsubscribe = firebase.auth.onAuthStateChanged(async (user) => {
      unsubscribe(); // fire once only
      if (user) {
        try {
          const snap = await firebase.database
            .ref(`user/${user.uid}/totpSecret`)
            .once('value');
          if (snap.val()) {
            this.setState({ cachedTotpSecret: snap.val() });
            sessionStorage.setItem('cachedTotpSecret', totpSnap.val());
            console.log('ReAuth: totpSecret reloaded after refresh');
          }
        } catch (err) {
          console.warn('ReAuth: could not reload totpSecret:', err.message);
        }
      }
    });
  }

  const { userdata } = this.props;

  let self = this;

  this.getCentralTime();

  try { fetchSettingsFromDB(); } catch (_) {}

  try { this._lcUnsub && this._lcUnsub(); } catch (_) {}

  try {
    this._lcCompany = userdata && userdata.companyID;
    this._lcUnsub = subscribeSettings({ companyID: this._lcCompany });
  } catch (_) {}

  // ================================
  // FIREBASE AUTH PERSISTENCE
  // ================================
  try {
    try {
      await firebase.auth.setPersistence(firebase.auth_.Auth.Persistence.LOCAL);
      console.log("✅ Firebase auth persistence set to LOCAL");
    } catch (e) {
      console.warn("Auth persistence error:", e);
    }

    console.log("✅ Firebase auth persistence set to LOCAL");
  } catch (e) {
    console.warn("Auth persistence error:", e);
  }

  // ================================
  // INVITE PARAMETER CAPTURE
  // ================================
  try {
    const params = new URLSearchParams(window.location.search || '');
    const inviteCompanyID = params.get('id');
    const inviterUID = params.get('u') || params.get('inviter') || null;

    if (inviteCompanyID) {
      const payload = {
        companyID: inviteCompanyID,
        inviterUID,
        ts: Date.now()
      };

      console.log('[INVITE] captured from URL', payload);
      localStorage.setItem('INVITE_DATA', JSON.stringify(payload));
    }
  } catch (e) {
    console.log('app.js invite capture error:', e.message);
  }

  // ================================
  // AXIOS INTERCEPTORS
  // ================================
  this._axiosReqInterceptor = axios.interceptors.request.use(
    (config) => {
      try { self.props.showLoader({ type: SHOW_LOADER }); } catch (_) {}
      return config;
    },
    (error) => {
      try { self.props.showLoader({ type: HIDE_LOADER }); } catch (_) {}
      return Promise.reject(error);
    }
  );

  this._axiosResInterceptor = axios.interceptors.response.use(
    (response) => {
      try { self.props.showLoader({ type: HIDE_LOADER }); } catch (_) {}
      return response;
    },
    (error) => {
      try { self.props.showLoader({ type: HIDE_LOADER }); } catch (_) {}
      return Promise.reject(error);
    }
  );

  // ================================
  // FIREBASE REALTIME DB CONNECTION MONITOR
  // ================================
  // try {
  //   this.connectedRef = firebase.database.ref(".info/connected");

  //   this.dbConnectionListener = this.connectedRef.on("value", (snapshot) => {
  //     const connected = snapshot.val() === true;

  //     this.setState({ showReconnecting: !connected });

  //     if (connected) {
  //       console.log("✅ Firebase Realtime DB connected");
  //     } else {
  //       console.warn("❌ Firebase Realtime DB disconnected");
  //     }
  //   });
  // } catch (e) {
  //   console.warn("DB connection monitor error:", e);
  // }

  // ================================
  // KEEP FIREBASE CONNECTION ALIVE
  // ================================
  try {
      this.keepAliveInterval = setInterval(() => {
      // Keep database connection alive
      firebase.database
        .ref(".info/serverTimeOffset")
        .once("value")
        .catch(() => {});

      // Silently refresh Auth token in background
      // Non-blocking — never throws, never affects ReAuth flow
      try {
        const user = firebase.auth.currentUser;
        if (user) {
          user.getIdToken(true).catch(() => {});
        }
      } catch (e) {}
    }, 60000);

    console.log("🔄 Firebase keepAlive ping enabled");
  } catch (e) {
    console.warn("KeepAlive error:", e);
  }

  // ================================
  // AUTH STATE LISTENER
  // ================================
  //let authChangeTimer = null;

this.authChangeTimer = null;

firebase.auth.onAuthStateChanged(function (user) {

  if (getIsValidatingCredentials()) {
    return;
  }

  // Clear timer
  if (self.authChangeTimer) {
    clearTimeout(self.authChangeTimer);
  }

  self.authChangeTimer = setTimeout(async () => {

    if (user) {

      try {
        const mode = getGoogleAuthMode ? getGoogleAuthMode() : 'idle';
        const uid = user.uid;

        const snapshot = await firebase.database
          .ref(`user/${uid}`)
          .once('value');

        const hasAccount = !!snapshot.val();

        if (!hasAccount && mode === 'login') {

          await firebase.auth.signOut();
          sessionStorage.removeItem('reAuthRequired');

          self.setState({ ...self.state, userloggedin: false });

          localStorage.removeItem('USER_LOGGED_IN');
          localStorage.removeItem('GLP_LOGGED_COMPANY');
          localStorage.removeItem('GLP_LOGGED_PROFILE');

          if (self.props.showToast) {
            self.props.showToast({
              type: 'warning',
              message: 'Google sign-in is restricted. Your email is not registered on this system. Go to CREATE ACCOUNT → Sign up with Google.',
              pos: 'top'
            });
          }

          return null;
        }

      } catch (_) {}

      let displayName = '';

      if (!user.displayName) {
        displayName = user.email.substring(0, user.email.indexOf('@'));
      } else {
        displayName = user.displayName;
      }

      let userobj = {
        uid: user.uid,
        displayName,
        email: user.email,
        emailVerified: user.emailVerified,
        refreshToken: user.refreshToken,
        metadata: user.metadata
      };

      self.props.getScores({
        uid: user.uid,
        email: user.email
      });

      self.setState({ ...self.state, userloggedin: true, lastActivityTime: Date.now() });
      
      localStorage.setItem('USER_LOGGED_IN', JSON.stringify(userobj));

      self.props.authStateChanged(userobj);

      self.props.loggedInProfileActions(userobj.uid)

      // ---- Cache totpSecret for offline ReAuth use ----
      // Loaded here while database is definitely connected,
      // so ReAuth never needs to make a database read.
      try {
        const totpSnap = await firebase.database
          .ref(`user/${user.uid}/totpSecret`)
          .once('value');
        if (totpSnap.val()) {
          self.setState({ cachedTotpSecret: totpSnap.val() });
          sessionStorage.setItem('cachedTotpSecret', totpSnap.val());
          console.log('App.js: totpSecret cached for ReAuth');
        }
      } catch (totpErr) {
        console.warn('App.js: could not cache totpSecret:', totpErr.message);
      }
      return user  // ← this line was already there
    }

    self.setState({ ...self.state, userloggedin: false });

    localStorage.removeItem('USER_LOGGED_IN');
    localStorage.removeItem('GLP_LOGGED_COMPANY');
    localStorage.removeItem('GLP_LOGGED_PROFILE');

    return null;

  }, 100);

});

  // ================================
  // GLOBAL FILE VIEWER EVENT
  // ================================
  try {
    window.addEventListener('OPEN_FILE_VIEWER', (evt) => {
      const file = evt && evt.detail ? evt.detail : null;
      if (file && self.openFileViewer) {
        self.openFileViewer(file);
      }
    });
  } catch (_) {}

  // ================================
  // CERTIFICATE EVENT LISTENER
  // ================================
  try {
    this._certEvtHandler = (evt) => {
      try {
        const label = (evt && evt.detail && evt.detail.label) || 'a new certificate';
        this.enqueueCertModal(label);
      } catch (_) {}
    };

    window.addEventListener('CERT_EARNED', this._certEvtHandler);
  } catch (_) {}

  // ================================
  // CERTIFICATE LISTENER INIT
  // ================================
  try {
    if (this.props.userdata && !this._certListenerRef) {
      this.setupCertificateListener();
    }
  } catch (_) {}

  // === NEW: Tab visibility / focus handler for long-inactive tabs ===
  // (This must be at the bottom of componentDidMount)
  this.authRefreshListener = this.handleTabVisibilityChange;
  document.addEventListener("visibilitychange", this.authRefreshListener);

    // ================================
  // INACTIVITY & RE-AUTH LISTENERS
  // ================================
  this.updateActivityTime(); // initial timestamp

  // User interaction listeners (throttled to avoid performance issues)
  const throttledActivity = this.throttle(this.updateActivityTime, 2000); // max once every 2 seconds

  document.addEventListener('click', throttledActivity);
  document.addEventListener('mousemove', throttledActivity);
  document.addEventListener('keypress', throttledActivity);
  document.addEventListener('scroll', throttledActivity);

  // Tab visibility for long background time
  this.authRefreshListener = this.handleTabVisibilityChange;
  document.addEventListener("visibilitychange", this.authRefreshListener);

  console.log("✅ Inactivity & re-auth listeners attached");
  //////////////////////////////////////////////////////////////////////////////////
  //   this.resetLastActivityTime = () => {
  //   this.setState({ lastActivityTime: Date.now() });
  // };

  // // Update last activity on real user actions
  // const activityEvents = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart'];
  
  // activityEvents.forEach(event => {
  //   document.addEventListener(event, this.resetLastActivityTime, { passive: true });
  // });

  // // Also listen to visibility change
  // document.addEventListener('visibilitychange', this.handleTabVisibilityChange);

  // // Initial value
  // if (!this.state.lastActivityTime) {
  //   this.setState({ lastActivityTime: Date.now() });
  // }
};

// Simple throttle helper
throttle = (func, limit) => {
  let inThrottle;
  return function () {
    const args = arguments;
    const context = this;
    if (!inThrottle) {
      func.apply(context, args);
      inThrottle = true;
      setTimeout(() => (inThrottle = false), limit);
    }
  };
};

  componentWillUnmount_12Mar() {
    try {
      if (this._axiosReqInterceptor !== undefined) {
        axios.interceptors.request.eject(this._axiosReqInterceptor);
      }
      if (this._axiosResInterceptor !== undefined) {
        axios.interceptors.response.eject(this._axiosResInterceptor);
      }
    } catch (_) {}
    // Unsubscribe LC settings live listener
    try { this._lcUnsub && this._lcUnsub(); } catch (_) {}
    // Clean up certificate listener
    this.teardownCertificateListener()
    // Clean up thresholds listener
    this.teardownThresholdsListener && this.teardownThresholdsListener()
    // Remove certificate earned event listener
    try { if (this._certEvtHandler) window.removeEventListener('CERT_EARNED', this._certEvtHandler) } catch (_) {}

  // Clean up Firebase listener
  if (this.connectedRef && this.dbConnectionListener) {
    this.connectedRef.off("value", this.dbConnectionListener);
  }

  }

componentWillUnmount() {

  try {
    if (this._axiosReqInterceptor !== undefined) {
      axios.interceptors.request.eject(this._axiosReqInterceptor);
    }

    if (this._axiosResInterceptor !== undefined) {
      axios.interceptors.response.eject(this._axiosResInterceptor);
    }
  } catch (_) {}

  try {
    if (this._lcUnsub) {
      this._lcUnsub();
    }
  } catch (_) {}

  try {
    this.teardownCertificateListener();
  } catch (_) {}

  try {
    if (this.teardownThresholdsListener) {
      this.teardownThresholdsListener();
    }
  } catch (_) {}

  try {
    if (this._certEvtHandler) {
      window.removeEventListener('CERT_EARNED', this._certEvtHandler);
    }
  } catch (_) {}

  try {
    if (this._openViewerHandler) {
      window.removeEventListener('OPEN_FILE_VIEWER', this._openViewerHandler);
    }
  } catch (_) {}

  try {
    if (this.connectedRef && this.dbConnectionListener) {
      this.connectedRef.off("value", this.dbConnectionListener);
      this.dbConnectionListener = null;
      this.connectedRef = null;
    }
  } catch (_) {}

  try {
    if (this._unsubscribeAuth) {
      this._unsubscribeAuth();
      this._unsubscribeAuth = null;
    }
  } catch (_) {}

  try {
    if (this.keepAliveInterval) {
      clearInterval(this.keepAliveInterval);
      this.keepAliveInterval = null;
    }
  } catch (_) {}

  try {
    if (this.authChangeTimer) {
      clearTimeout(this.authChangeTimer);
      this.authChangeTimer = null;
    }
  } catch (_) {}

    this.detachDbConnectionListener();  
        // Clean up visibility listener
    if (this.authRefreshListener) {
      document.removeEventListener("visibilitychange", this.authRefreshListener);
    }

  // Clean up inactivity listeners
  document.removeEventListener('click', this.throttledActivity);   // if you saved the reference
  document.removeEventListener('mousemove', this.throttledActivity);
  document.removeEventListener('keypress', this.throttledActivity);
  document.removeEventListener('scroll', this.throttledActivity);
  if (this.authRefreshListener) {
    document.removeEventListener("visibilitychange", this.authRefreshListener);
  }
  
    window.removeEventListener('focus', this.checkInactivityAndReAuth);
    if (this.inactivityCheckInterval) {
      clearInterval(this.inactivityCheckInterval);
    }
  /////////////////////////////////////////////////////////////////////////////////////
  //   const activityEvents = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart'];
  
  // activityEvents.forEach(event => {
  //   document.removeEventListener(event, this.resetLastActivityTime);
  // });

  // document.removeEventListener('visibilitychange', this.handleTabVisibilityChange);
}

  // ---------- Certificate threshold announcement (global) ----------
  _cleanMainCategory = (name) => {
    if (!name) return ''
    const parts = String(name).split(/\s*[–—-]\s*/)
    return parts[0].trim()
  }

  _getLevelName = (level) => {
    switch (level) {
      case 1: return 'Foundational'
      case 2: return 'Advanced'
      case 3: return 'Distinguished'
      case 4: return 'Elite'
      case 5: return 'Pinnacle'
      default: return ''
    }
  }

  _computeLevel = (lc, thresholds) => {
    if (!lc || lc <= 0) return 0
    let lvl = 0
    for (let i = 0; i < thresholds.length; i++) {
      if ((lc + 1e-9) >= thresholds[i]) lvl = i + 1
    }
    return lvl
  }

  _getThresholdsFromLS = () => {
    try {
      const ls = localStorage.getItem('CERT_THRESHOLDS')
      if (ls) {
        const arr = JSON.parse(ls)
        if (Array.isArray(arr) && arr.length) {
          const cleaned = arr.map(Number).filter((n) => Number.isFinite(n) && n > 0).sort((a,b)=>a-b)
          if (cleaned.length) return cleaned
        }
      }
    } catch (_) {}
    // If not present, return empty to avoid App-level defaults. MyTestResume owns thresholds.
    return []
  }

  _buildCurrentCertificateLevels = (rows, thresholds) => {
    // Aggregate LC similar to MyTestResume
    const byCatSub = {}
    const bySubAll = {}
    const byCategoryTotals = {}
    const MIN_TESTS_FOR_CERT = 1

    // Normalize rows and recompute pass/LC if needed
    const normalized = Object.keys(rows || {}).map((k) => ({ surveyid: k, ...rows[k] }))
      .map((r) => {
        const total = parseInt(r.totalAnswered || r.qlen || 0)
        const score = parseInt(r.testscore || 0)
        const passed = (typeof r.testPassed === 'boolean') ? r.testPassed : calculateTestPassed(score, total, r.difficulty || 'basic')
        const lc = (typeof r.lcEarned === 'number') ? r.lcEarned : (passed ? calculateLCEarned(score, true, r.difficulty || 'basic') : 0)
        return { ...r, testPassed: passed, lc }
      })
      .filter((r) => r.testPassed)

    normalized.forEach((r) => {
      const cat = r.leadCategory || r.categoryType || 'general'
      const sub = r.leadSubCategory || ''
      const lc = Number(r.lc || r.lcEarned || 0)
      if (!sub) return
      byCatSub[cat] = byCatSub[cat] || {}
      byCatSub[cat][sub] = byCatSub[cat][sub] || { lc: 0, tests: 0 }
      byCatSub[cat][sub].lc += lc
      byCatSub[cat][sub].tests += 1

      bySubAll[sub] = bySubAll[sub] || { lc: 0, tests: 0, categories: new Set() }
      bySubAll[sub].lc += lc
      bySubAll[sub].tests += 1
      bySubAll[sub].categories.add(cat)

      byCategoryTotals[cat] = byCategoryTotals[cat] || { lc: 0, tests: 0, subs: new Set() }
      byCategoryTotals[cat].lc += lc
      byCategoryTotals[cat].tests += 1
      byCategoryTotals[cat].subs.add(sub)
    })

    // Build level map: key -> { level, label }
    const levelsMap = {}

    // Specialized
    Object.keys(byCatSub).forEach((cat) => {
      Object.keys(byCatSub[cat]).forEach((sub) => {
        const info = byCatSub[cat][sub]
        if (info.tests >= MIN_TESTS_FOR_CERT) {
          const level = this._computeLevel(info.lc, thresholds)
          if (level > 0) {
            const key = `spec:${cat}::${sub}`
            const label = `Real-Time ${this._getLevelName(level)} Certificate In ${this._cleanMainCategory(cat)} ${sub}`
            levelsMap[key] = { level, label, type: 'specialized', cat, sub }
          }
        }
      })
    })

    // General
    Object.keys(bySubAll).forEach((sub) => {
      const info = bySubAll[sub]
      const acrossMultipleCats = info.categories && info.categories.size > 1
      if (acrossMultipleCats && info.tests >= MIN_TESTS_FOR_CERT) {
        const level = this._computeLevel(info.lc, thresholds)
        if (level > 0) {
          const key = `gen:${sub}`
          const label = `Real-Time ${this._getLevelName(level)} Certificate In Leadership -  ${sub}`
          levelsMap[key] = { level, label, type: 'general', sub }
        }
      }
    })

    // Category-wide
    Object.keys(byCategoryTotals).forEach((cat) => {
      const info = byCategoryTotals[cat]
      const acrossMultipleSubs = info.subs && info.subs.size > 1
      if (acrossMultipleSubs && info.tests >= MIN_TESTS_FOR_CERT) {
        const level = this._computeLevel(info.lc, thresholds)
        if (level > 0) {
          const key = `cat:${cat}`
          const label = `Real-Time ${this._getLevelName(level)} Certificate In ${this._cleanMainCategory(cat)} Leadership`
          levelsMap[key] = { level, label, type: 'category', cat }
        }
      }
    })

    return levelsMap
  }

  setupCertificateListener = () => {
    try {
      const user = this.props.userdata
      if (!user) return
      const companyID = user.real_companyID || user.companyID
      const personid = user.userID
      if (!companyID || !personid) return
      const ref = firebase.database.ref(`userTestResults/${companyID}/${personid}`)
      this._certListenerRef = ref
      const storageKey = `CERT_LEVELS_${companyID}_${personid}`

      this._certListenerHandle = ref.on('value', (snap) => {
        try {
          // Read thresholds provided by MyTestResume via localStorage (no App-owned defaults)
          const thresholds = this._getThresholdsFromLS()
          const val = snap.val() || {}
          const currentLevels = this._buildCurrentCertificateLevels(val, thresholds)
          // Load baseline
          let baselineRaw = null
          try { baselineRaw = localStorage.getItem(storageKey) } catch (_) {}
          let baseline = {}
          let hasBaseline = !!baselineRaw
          try { baseline = hasBaseline ? (JSON.parse(baselineRaw) || {}) : {} } catch (_) { baseline = {}; hasBaseline = false }

          // On first run without an existing baseline, seed baseline and do NOT announce
          if (!hasBaseline) {
            try { localStorage.setItem(storageKey, JSON.stringify(currentLevels)) } catch (_) {}
            return
          }

          // Find increases relative to saved baseline only
          const deltas = Object.keys(currentLevels).map((k) => {
            const cur = Number(currentLevels[k].level || 0) || 0
            const prev = Number((baseline[k] && baseline[k].level) ? baseline[k].level : 0) || 0
            return { key: k, cur, prev, meta: currentLevels[k] }
          }).filter((x) => x.cur > x.prev)

          if (deltas.length > 0) {
            // Announce all newly reached levels; queue handles multiple
            deltas.sort((a, b) => b.cur - a.cur)
            deltas.forEach((d) => {
              const label = d.meta && d.meta.label ? String(d.meta.label) : 'a new area'
              try { this.enqueueCertModal(label) } catch (_) {}
            })
          }

          // Persist new baseline regardless
          try { localStorage.setItem(storageKey, JSON.stringify(currentLevels)) } catch (_) {}
        } catch (e) {
         // console.log('app.js error 6: ', error);
          try { console.error('[CERT_LISTENER]', e) } catch (_) {}
        }
      })
    } catch (e) {
      // ignore
    }
  }

  teardownThresholdsListener = () => {
    try {
      if (this._certTRef && this._certTHandle) {
        this._certTRef.off('value', this._certTHandle)
      }
    } catch (_) {}
    this._certTRef = null
    this._certTHandle = null
  }

  teardownCertificateListener = () => {
    try {
      if (this._certListenerRef && this._certListenerHandle) {
        this._certListenerRef.off('value', this._certListenerHandle)
      }
    } catch (_) {}
   // console.log('app.js error 7: ', error);
    this._certListenerRef = null
    this._certListenerHandle = null
  }

  navigateToCertificates = () => {
    try {
      if (this._history && this._history.push) {
        this._history.push('/my-resume')
      } else if (this.props.history && this.props.history.push) {
        this.props.history.push('/my-resume')
      } else {
        window.location.href = '/my-resume'
      }
    } catch (_) {
      try { window.location.href = '/my-resume' } catch (_) {}
    } finally {
      try { this.closeCertModal() } catch (_) {}
    }
  }

  enqueueCertModal = (label) => {
    try {
      const queue = Array.isArray(this.state.certQueue) ? this.state.certQueue.slice() : []
      queue.push(label)
      if (!this.state.showCertModal) {
        const next = queue.shift()
        this.setState({ showCertModal: true, certModalLabel: next, certQueue: queue })
      } else {
        this.setState({ certQueue: queue })
      }
    } catch (_) {}
  }

  closeCertModal = () => {
    try {
      const queue = Array.isArray(this.state.certQueue) ? this.state.certQueue.slice() : []
      if (queue.length > 0) {
        const next = queue.shift()
        this.setState({ showCertModal: true, certModalLabel: next, certQueue: queue })
      } else {
        this.setState({ showCertModal: false, certModalLabel: '' })
      }
    } catch (_) {
      this.setState({ showCertModal: false, certModalLabel: '' })
    }
  }

handleVerifyReAuthTOTP = async (code) => {
  console.log('=== handleVerifyReAuthTOTP STARTED ===', new Date().toISOString());
  console.log('USER_LOGGED_IN present:', !!localStorage.getItem('USER_LOGGED_IN'));
  console.log('firebase.auth.currentUser:', firebase.auth.currentUser?.uid ?? 'NULL');
  console.log('cachedTotpSecret (state):', !!this.state.cachedTotpSecret);
  console.log('cachedTotpSecret (sessionStorage):', !!sessionStorage.getItem('cachedTotpSecret'));
  
  try {
    // Step 1: Get UID
    let uid = null;
    let storedUser = null;
    try {
      const raw = localStorage.getItem('USER_LOGGED_IN');
      if (raw) {
        storedUser = JSON.parse(raw);
        uid = storedUser?.uid;
      }
    } catch (e) {}
    if (!uid) uid = firebase.auth.currentUser?.uid;
    if (!uid) throw new Error("Session expired. Please refresh and log in again.");

    // Step 2: Get totpSecret
    let totpSecret = this.state.cachedTotpSecret
      || sessionStorage.getItem('cachedTotpSecret');
    if (!totpSecret) {
      try {
        const profile = JSON.parse(localStorage.getItem('GLP_LOGGED_PROFILE') || '{}');
        totpSecret = profile?.totpSecret;
      } catch (e) {}
    }
    if (!totpSecret) throw new Error("Security settings not found. Please refresh and log in again.");

    // Step 3: Verify TOTP client-side
    const totp = new OTPAuth.TOTP({
      issuer: 'ThinkLead',
      algorithm: 'SHA1',
      digits: 6,
      period: 30,
      secret: OTPAuth.Secret.fromBase32(totpSecret),
    });
    const delta = totp.validate({ token: code, window: 1 });
    if (delta === null) {
      throw new Error("Invalid code. Please check Google Authenticator and try again.");
    }

    // // Step 3b: If Firebase session is dead, restore it via custom token
    // console.log('ReAuth: restoring session via backend custom token');
    // console.log('ReAuth: about to call backend, navigator.onLine:', navigator.onLine);
    // console.log('ReAuth: document.visibilityState:', document.visibilityState);
    // console.log('ReAuth: FB_URL value:', FB_URL);
    // //console.log('ReAuth: full endpoint:', `${FB_URL}/m153-reauthToken`);

    // try {
    //   const verifyRes = await axios.post(`${FB_URL}/m153-reauthToken`, {
    //     params: { uid, totpCode: code }
    //   });

    //   console.log('ReAuth: backend response:', verifyRes.data);

    //   if (!verifyRes.data?.success) {
    //     throw new Error(verifyRes.data?.error || "Backend verification failed.");
    //   }

    //   const customToken = verifyRes.data.customToken;
    //   if (!customToken) {
    //     throw new Error("No custom token returned from backend.");
    //   }

    //   // Wait for onAuthStateChanged to confirm session is fully restored
    //   await new Promise((resolve, reject) => {
    //     const unsubscribe = firebase.auth.onAuthStateChanged((user) => {
    //       unsubscribe();
    //       if (user) {
    //         resolve(user);
    //       } else {
    //         reject(new Error("Session could not be restored. Please log in again."));
    //       }
    //     });
    //     firebase.auth.signInWithCustomToken(customToken).catch(reject);
    //   });

    //   console.log('✅ Firebase session restored and confirmed');

    // } catch (fnErr) {
    //   console.error('=== Step 3b custom token restore FAILED ===');
    //   console.error('fnErr.message:', fnErr.message);
    //   console.error('fnErr.response?.data:', fnErr.response?.data);

    //   sessionStorage.removeItem('reAuthRequired');
    //   localStorage.removeItem('reAuthRequired');
    //   this.setState({ showReAuthScreen: false, userloggedin: false });
    //   throw new Error("Your session has fully expired. Please log in again.");
    // }

    // Step 3b: Only restore via custom token if Firebase session is actually dead
    if (!firebase.auth.currentUser) {
      console.log('ReAuth: Firebase session expired — restoring via backend custom token');
      try {
        const verifyRes = await axios.post(`${FB_URL}m153-reauthToken`, {
          params: { uid, totpCode: code }
        });

        if (!verifyRes.data?.success) {
          throw new Error(verifyRes.data?.error || "Backend verification failed.");
        }

        const customToken = verifyRes.data.customToken;
        if (!customToken) {
          throw new Error("No custom token returned from backend.");
        }

        await new Promise((resolve, reject) => {
          const unsubscribe = firebase.auth.onAuthStateChanged((user) => {
            unsubscribe();
            if (user) resolve(user);
            else reject(new Error("Session could not be restored. Please log in again."));
          });
          firebase.auth.signInWithCustomToken(customToken).catch(reject);
        });

        console.log('✅ Firebase session restored and confirmed');

      } catch (fnErr) {
        console.error('=== Step 3b custom token restore FAILED ===');
        console.error('fnErr.message:', fnErr.message);

        sessionStorage.removeItem('reAuthRequired');
        localStorage.removeItem('reAuthRequired');
        this.setState({ showReAuthScreen: false, userloggedin: false });
        throw new Error("Your session has fully expired. Please log in again.");
      }
    } else {
      console.log('ReAuth: Firebase session still alive, skipping custom token restore');
    }

    // Step 4: Clear the reAuth flags
    sessionStorage.removeItem('reAuthRequired');
    localStorage.removeItem('reAuthRequired');

    // Step 5: Hide the ReAuth screen, mark user as logged in,
    // bring the Realtime Database back online, reset inactivity timer,
    // and notify Redux so all connected components re-fetch their data
    firebase.database.goOnline();
    console.log('✅ Firebase Realtime Database brought back online');

    const now = Date.now();
    this.setState({
      showReAuthScreen: false,
      userloggedin: true,
      lastActivityTime: now,
      reAuthKey: this.state.reAuthKey + 1
    });
    localStorage.setItem('lastActivityTime', now.toString());
    this.props.dispatch({ type: 'REAUTH_SUCCESS' });

    // Step 6: Re-trigger Redux profile reload so all components get fresh data
    try {
      if (!storedUser) {
        const raw = localStorage.getItem('USER_LOGGED_IN');
        if (raw) storedUser = JSON.parse(raw);
      }
      if (storedUser?.uid) {
        this.props.authStateChanged(storedUser);
        this.props.loggedInProfileActions(storedUser.uid);
        this.props.getScores({ uid: storedUser.uid, email: storedUser.email });
        console.log('✅ ReAuth: Redux profile reload triggered for', storedUser.uid);
      }
    } catch (e) {
      console.warn('ReAuth: could not reload profile:', e.message);
    }

} catch (err) {
  console.error("ReAuth failed:", err.message);
  console.log('=== handleVerifyReAuthTOTP FAILED — full state dump ===');
  console.log('USER_LOGGED_IN:', localStorage.getItem('USER_LOGGED_IN'));
  console.log('GLP_LOGGED_PROFILE:', localStorage.getItem('GLP_LOGGED_PROFILE') ? 'present' : 'MISSING');
  throw err;
}
};

getCentralTime = async () => {
  try {
    const res = await axios.post(`${FB_URL}/m122-centraltime`, {});

    if (res.data?.success === true) {
      let centralDate;

      // Prefer timestamp (number) – most reliable
      if (typeof res.data.timestamp === 'number') {
        centralDate = new Date(res.data.timestamp);
      }
      // Fallback to iso string
      else if (typeof res.data.iso === 'string') {
        centralDate = new Date(res.data.iso);
      }
      // Last resort: parse fdate string
      else if (typeof res.data.fdate === 'string') {
        const [datePart, timePart] = res.data.fdate.split(' ');
        const [year, month, day] = datePart.split('-').map(Number);
        const [hour, minute] = timePart.split(':').map(Number);
        centralDate = new Date(year, month - 1, day, hour, minute, 0);
      }

      if (centralDate && !isNaN(centralDate.getTime())) {
        this.setState({ timeNow: centralDate });
        console.log('Central time set:', centralDate.toISOString());
      } else {
        throw new Error('Invalid date received');
      }
    } else {
      console.log("Failed to fetch central time – success flag missing");
      this.setState({ timeNow: null });
    }
  } catch (err) {
    console.error("getCentralTime failed:", err);
    this.setState({ timeNow: null });
  }
};

  // In updateLoginStatus:
  updateLoginStatus = () => {
    this.setState({ ...this.state, userloggedin: true })
    const now = Date.now();
    self.setState({ ...self.state, userloggedin: true, lastActivityTime: now });
    localStorage.setItem('lastActivityTime', now.toString());
  }

  render() {
    const { dbReady } = this.state;


  if (window.location.pathname === '/LinkAccount') {
    return (
      <Router>
        <Route exact path='/LinkAccount' component={LinkAccount} />
      </Router>
    );
  }
    const {
      userloggedin,
      loading,
      openfileviewer,
      filetype,
      filepath,
      filename,
      showCertModal,
      certModalLabel,
      timeNow,
    } = this.state
    const {
      classes,
      theme,
      variant,
      pos,
      showprogress,
      message,
      opentoast,
      userdata,
      showprofiledlg
    } = this.props

    let self = this

   if (this.state.showReAuthScreen) {
    return (
      <ReAuthTOTP 
        onVerifyTOTP={this.handleVerifyReAuthTOTP}
        totpEnabled={true}   // or pull from user data
      />
    );
  }     
  
  console.log('app-userdata: ', this.props.userdata);

    return (
     <Router ref={(r) => { try { this._history = (r && r.history) || (r && r.props && r.props.history) } catch (_) {} }}>
        <div>
          {/* <Switch> */}
        {userloggedin ? (
          <div className={classNames(classes.content)} key={`auth-${this.state.reAuthKey}`}>
            <Navbar
              themeColor='#ffffff'
              openFileViewer={this.openFileViewer}
              speedDPath={this.props.speedDPath}
            />
            <FCMInitialiser uid={firebase.auth.currentUser?.uid || userdata?.uid || userdata?.id} />
            <div style={{ 
              margin: isMobile ? '-45px 0 0 0' : '-20px 0 0 0', 
              padding: 0 
              }}>
              <NotificationStatus uid={firebase.auth.currentUser?.uid || userdata?.uid || userdata?.id} />
            </div>          
              {userdata ? (
                <React.Fragment>
                  {/* <Route exact path="/" component={Organisational} /> */}
                  {/* <Route path="/organisational" component={Organisational} /> */}
                  {APP_TYPE === 'PUBLIC' ? (
                    <div>  
                    {/* { newPayBool==='nothing: it should be set to true with prev individual patreon component'? //activate confirmation of pledge AUTOMATICALLY
                      <Route exact path='/' render={(props) => <Gotopatreon rep={this.props.rep ? this.props.rep : true} {...props} />}  />
                      :
                      <Route exact path='/' render={(props) => (
                        <Ilead
                          {...props}
                          openFileViewer={this.openFileViewer}
                        />
                      )} />} */}

                       <Route exact path='/' render={(props) => (
                        <AgentDashboard />
                        // <Ilead
                        //   {...props}
                        //   openFileViewer={this.openFileViewer}
                        // />
                      )} />

                      {userdata.companyID ? (
                        <Route
                          exact
                          path='/organisational'
                          render={(props) => (
                            <React.Fragment>
                              <Organisational
                                openFileViewer={this.openFileViewer}
                                {...props}
                              />
                            </React.Fragment>
                          )}
                        />
                      ) : null}
                    </div>
                  ) : (
                    <div>
                      <Route
                        exact
                        path='/'
                        render={(props) => (
                          <React.Fragment>                         
                            <Organisational
                              openFileViewer={this.openFileViewer}
                              {...props}
                            />
                          </React.Fragment>
                        )}
                      />
                      <Route
                        exact
                        path='/organisational'
                        render={(props) => (
                          <React.Fragment>
                            <Organisational
                              openFileViewer={this.openFileViewer}
                              {...props}
                            />
                          </React.Fragment>
                        )}
                      />
                    </div>
                  )}
                  <Route
                    exact
                    path='/groupmessages'
                    render={(props) => (
                      <React.Fragment>
                        <MyGroups
                          openFileViewer={this.openFileViewer}
                          {...props}
                        />
                      </React.Fragment>
                    )}
                  />
                  
                  <Route exact path='/wallet' component={Wallet} />
                  <Route exact path='/pldp' component={PLDP} />
                  {/* <Route exact path='/pldp' component={pldp_ledain} /> */}
                  <Route exact path='/favourites' component={Favourites} />
                  <Route exact path='/my-tests' component={MyTestResults} />
                  <Route exact path='/my-resume' component={MyTestResume} />
                  <Route exact path='/ilead' render={(props) => (
                    <Ilead
                      {...props}
                      openFileViewer={this.openFileViewer}
                    />
                  )} />
                  {/* <Route exact path='/about' component={About} /> */}
                  <Route exact path='/LeaderOnList' component={LeaderOnList} />
                  <Route exact path='/mevcoin' component={mevcoin} />

                  {/* <Route exact path='/' component={LeaderOnList} /> */}
                  <Route
                    exact
                    path='/globalcontributors'
                    render={(props) => (
                      <React.Fragment>
                        <GcThoughts
                          openFileViewer={this.openFileViewer}
                          {...props}
                        />
                      </React.Fragment>
                    )}
                  />
                  <Route
                    exact
                    path='/daily'
                    render={(props) => (
                      <React.Fragment>
                        <DailyThoughts
                          openFileViewer={this.openFileViewer}
                          {...props}
                        />
                      </React.Fragment>
                    )}
                  />
                  <Route
                    exact
                    path='/myposts'
                    render={(props) => (
                      <React.Fragment>
                        <MyPosts
                          openFileViewer={this.openFileViewer}
                          {...props}
                        />
                      </React.Fragment>
                    )}
                  />
                  <Route exact path='/videos' component={Videos} />
                  <Route exact path='/podcasts' component={Podcasts} />
                  <Route
                    exact
                    path='/articles'
                    render={(props) => (
                      <React.Fragment>
                        <Articles
                          openFileViewer={this.openFileViewer}
                          {...props}
                        />
                      </React.Fragment>
                    )}
                  />
                  <Route exact path='/readarticle' component={ReadArticles} />
                  <Route exact path='/ebooks' component={Ebooks} />
                  <Route exact path='/poe' component={Poe} />
                  <Route path='/bookshop' component={Bookshop} />
                  <Route exact path='/analytics' component={Analytics} />
                  {/* <Route path='/surveys' component={Surveys} /> */}
                  <Route
                    exact
                    path='/pointssurveys'
                    component={PointsSurveys}
                  />
                  <Route exact path='/companies' component={Companies} />
                  <Route exact path='/companyadmin' component={CompanyAdmin} />
                  <Route exact path='/admin/lc-settings' component={LcSettings} />
                  <Route exact path='/admin/lc-earnings' component={LcEarningsMonitor} />
                  <Route exact path='/orgEval' component={orgEval} />
                  <Route exact path='/orgStats' component={orgStats} />
                  <Route exact path='/genEval' component={genEval} />
                  <Route exact path='/genStats' component={genStats} />
                  <Route exact path='/getmembers' component={getmembers} />
                  <Route exact path='/BlacklistTable' component={BlacklistTable} />
                  <Route exact path='/Agentlist' component={Agentlist} />
                  <Route exact path='/SafeguardingDashboard' component={SafeguardingDashboard} /> 
                  <Route exact path='/liqA' component={liqA} />
                  <Route exact path='/liqB' component={liqB} />

                  <Route exact path='/companies' component={Companies} />

                  <Route exact path='/gotomalik' component={GotoMalik} />
                  <Route exact path='/gotopersonpledge' component={GotoPersonPledge} />
                  <Route exact path='/gotobulkpledge' component={GotoBulkPledge} />
                  <Route exact path='/gotoflexpledge' component={GotoFlexPledge} />
                  <Route exact path='/GotoGIFpledge' component={GotoGIFpledge} />
                  <Route exact path='/ExecutiveMembersTable' component={ExecutiveMembersTable} />
                  <Route exact path='/teststats' component={Teststats} />
                  <Route exact path='/MyCertificates' component={MyCertificates} />

                  <Route exact path='/AgentDashboard/:agentId?' component={AgentDashboard} />
                  <Route path="/mevprice" component={MevPriceWidget} />

                  <Route
                    exact
                    path='/gotocalf'
                    render={(props) => (
                      <React.Fragment>
                        <Gotocalf
                          // calfname={this.props.userdata ?
                          //   this.props.userdata.calfname
                          //   : 'none'
                          // }
                          calfemail={
                            this.props.userdata
                              ? this.props.userdata.email
                              : 'none'
                          }
                          // calfpassword={this.props.userdata ?
                          //   this.props.userdata.calfpassword
                          //   : 'none'
                          // }
                          {...props}
                        />
                      </React.Fragment>
                    )}
                  />

                  <Route
                    exact
                    path='/gotopatreon'
                    render={(props) => (
                      <React.Fragment>
                        <Gotopatreon
                          // calfname={this.props.userdata ?
                          //   this.props.userdata.calfname
                          //   : 'none'
                          // }
                          calfemail={
                            this.props.userdata
                              ? this.props.userdata.email
                              : 'none'
                          }
                          // calfpassword={this.props.userdata ?
                          //   this.props.userdata.calfpassword
                          //   : 'none'
                          // }
                          {...props}
                        />
                      </React.Fragment>
                    )}
                  />                 
                  {/* <Route path='/gotogli' component={() => {
                      window.location.href = 'https://www.google.com';
                       return null;
                     }}/>  */}
                  {/* <Route path='/seamlesscertificate' component={SeamlessCertificate} />  */}
                  <Route exact path='/search' component={Search} />
                  <Route exact path='/userprofile' component={UserProfile} />
                  <Route
                    exact
                    path='/groupdetails/:id'
                    component={GroupDetails}
                  />
                  <Route
                    exact
                    path='/studymaterials'
                    component={StudyMaterials}
                  />
                  <Route exact path='/programmes' component={Programmes} />
                  <Route
                    exact
                    path='/surveyconfigurations'
                    component={SurveyConfigurations}
                  />
                  <Route exact path='/facilitators' component={Facilitators} />
                  <Route exact path='/groupcourses' component={GroupCourses} />
                  <Route exact path='/groups' component={Groups} />
                  <Route exact path='/MEVSettings' component={MEVSettings} />
                  <Route exact path='/WebSourceSettings' component={WebSourceSettings} />
                  <Route exact path='/cosign' component={cosign} />
                  <Route exact path='/monitor' component={monitor} />
                  <Route exact path='/fixcompany' component={fixcompany} />

                  <Route exact path='/filerepository' component={FileRepo} />
                  <Route exact path='/tokens' component={Tokens} />
                  {(APP_TYPE === 'PUBLIC' || APP_TYPE === 'CORPORATE') &&
                  // company admin for public app superuser
                  ACCESS_COMPETENCIES[userdata.companyID] ? (
                      <Route
                        exact
                        path='/competencies'
                        component={Competencies}
                      />
                    ) : (
                      <Redirect to='/' />
                    )}
                  {[
                    '/filtered-articles',
                    '/filtered-thoughts',
                    '/filtered-podcasts',
                    '/filtered-videos',
                    '/filtered-group-posts'
                  ].map((path, index) => (
                    <Route
                      exact
                      path={path}
                      component={FilteredPosts}
                      key={index}
                    />
                  ))}

                  {['/surveys'].map((path, index) => (
                    <Route exact path={path} component={Surveys} key={index} />
                  ))}

                  {HIDE_ADD_BTN[this.props.speedDPath] && userdata &&
                  this.props.speedDPath !== undefined ? null : (
                      <MainSpeedDial
                        hidden={BLOCKED_USER_TYPES[userdata.userType]}
                        openModal={this.openModal}
                        userType={userdata.userType}
                        usrIDD={userdata.userID}
                      // speedPath={this.props.speedDialPath}
                      />   
                     // <div/>                                
                     )
                    }
                  <Route exact path='/individuals' component={Individuals} />
                  <Route exact path='/organizations' component={Organizations} />
                  <Route exact path='/support-contact' component={SupportContact} />
                  <Route exact path='/test-otp' component={TestOTP} />
                  <Route exact path='/individuals' component={Individuals} />               
                  <Route exact path='/LinkAccount' component={LinkAccount} />

                  {/* <Route exact path='/AgentSignup' component={AgentSignup} /> */}
                  {/* <Route exact path="/link" element={<LinkAccount />} /> */}

                </React.Fragment>
              ) : null}

              <Route path='/tutorials' component={TutorialsPage} />
              <Route path='/tcs' component={TermsConditions} />
              <Route path='/terms-conditions' component={TermsConditions} />

              <AddModal
                handleModalClose={this.handleModalClose}
                dialogname={this.state.dialogname}
                opendialog={this.state.opendialog}
                {...this.props}
              />
            </div>
          ) : (


   <div>
    <Switch>
      <Route exact path='/reset-password' component={ForgotPassword} />
      <Route exact path='/support-contact' component={SupportContact} />
      <Route exact path='/LinkAccount' component={LinkAccount} />
      <Route exact path='/AgentSignup' component={AgentSignup} />
      {[
        '/filtered-articles',
        '/filtered-thoughts',
        '/filtered-podcasts',
        '/filtered-videos',
        '/filtered-group-posts'
      ].map((path, index) => (
        <Route path={path} render={(props) => <LandingPage {...props} updateLoginStatus={this.updateLoginStatus} />} key={index} />
      ))}
      {APP_TYPE === 'PUBLIC' ? (
        <Route exact path='/signup' render={(props) => <LandingPage {...props} updateLoginStatus={this.updateLoginStatus} />} />
      ) : null}
      <Route render={(props) => <LandingPage {...props} updateLoginStatus={this.updateLoginStatus} />} />
    </Switch>
  </div>     
         )}
          {/* </Switch> */}

          <ToastMessage
            opentoast={opentoast}
            variant={variant}
            message={message}
            pos={pos}
          />
          <ToastContainer />


          {/* <LoaderBar showprogress={showprogress} /> */}

          <ViewUserProfile showprofiledlg={showprofiledlg} />

          <FileViewer
            filetype={filetype}
            filename={filename}
            filepath={filepath}
            opendialog={openfileviewer}
            handleClose={this.handleFileViewerClose}
          />


          {/* Certificate Announcement Snackbar (bottom-left) */}
          <Snackbar
            anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
            open={!!showCertModal}
            onClose={this.closeCertModal}
            ContentProps={{ 'aria-describedby': 'cert-message-id', style: { backgroundColor: '#1b5e20', color: '#ff00ff' } }}
            message={<span id='cert-message-id'>🎉 Congratulations! You just earned a {certModalLabel}</span>}
            action={[
              <Button key='view' style={{ color: '#ff00ff' }} onClick={this.navigateToCertificates}>
                View Certificates
              </Button>,
              <IconButton key='close' aria-label='close' color='inherit' onClick={this.closeCertModal}>
                <CloseIcon />
              </IconButton>
            ]}
          />


        </div>
       </Router>
    )
  }
}

App.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired
}

const GLPApp = withStyles(styles, { withTheme: true })(App)

const mapStateToProps = (state) => {
  return {
    opentoast: state.toast.open,
    showprogress: state.loader.showloader,
    variant: state.toast.variant,
    pos: state.toast.pos,
    message: state.toast.message,
    auth: state.auth.auth,
    speedDPath: state.speedDialP.speedDPath,
    showprofiledlg: state.userbiography.showprofiledlg,
    userdata: state.userDialog.userDetails[0] || null,

    themeColor: state.loggedInCompany.companydata
      ? state.loggedInCompany.companydata.primaryColor
      : '#e15225'
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    showToast: (params) => dispatch(showToast(params)),
    hideToast: () => dispatch(hideToast()),
    showLoader: (params) => dispatch(showLoader(params)),
    hideLoader: (params) => dispatch(hideLoader(params)),
    authStateChanged: (userobj) => dispatch(authStateChanged(userobj)),
    loggedInProfileActions: (params) =>
      dispatch(loggedInProfileActions(params)),
    getScores: (params) => dispatch(getScores(params)),
    getUserProfile: (params) => dispatch(getUserProfile(params)),
    fetchCompanyData:  (params) => dispatch(fetchCompanyData(params)),
    createThought: (params) => dispatch(createThought(params)),
    createVideo: (params) => dispatch(createVideo(params)),
    createPodcast: (params) => dispatch(createPodcast(params)),
    createArticle: (params) => dispatch(createArticle(params)),
    addMorePoints: (params) => dispatch(addMorePoints(params))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(GLPApp)
